import InputGroup from './InputGroup.vue';
import Text from './Text.vue';

const InputGroupComponent = Object.assign(InputGroup, {
  Text,
});

export default InputGroupComponent;
